import React, { useState, useEffect } from 'react';
import { useForm } from '@laramie/ui';
import {CloneObject} from '../../../utils/helpers';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {TIPS} from "../../../consts/tips";
import Modal from '../../common/Modal';
import {Accordion, FormLabel} from "../../common";

import { useFormErrors } from '../../hooks/useFormErrors';
import { DatePickerCustom, FormError, InputLista } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const JuicioCitacionModal = (props) => {

    const entityInit = {
        id: 0,
        idApremio: 0,
        fechaCitacion: null,
        idTipoCitacion: 0,
        observacion: ''
    };
    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity}
        });
        formSet({
            idApremio: props.data.entity.idApremio,
            fechaCitacion: props.data.entity.fechaCitacion,
            idTipoCitacion: props.data.entity.idTipoCitacion,
            observacion: props.data.entity.observacion
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idApremio: 0,
        fechaCitacion: null,
        idTipoCitacion: 0,
        observacion: ''
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (validate()) {
            let row = CloneObject(state.entity);

            row.idApremio = parseInt(formValues.idApremio);
            row.fechaCitacion = formValues.fechaCitacion;
            row.idTipoCitacion = parseInt(formValues.idTipoCitacion);
            row.observacion = formValues.observacion;

            props.onConfirm(row);
        }
        ;
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.fechaCitacion == null) errors.fechaCitacion = VALIDATION_MESSAGE.REQUIRED_DATE
        if (formValues.idTipoCitacion <= 0) errors.idTipoCitacion = VALIDATION_MESSAGE.REQUIRED_OPTION

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Juicio citación: ${(state.entity.id > 0) ? `N° ${state.entity.id}` : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.JUICIO_CITACION_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Citación" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="col-12 col-md-3">
                                                <FormLabel htmlFor="fechaCitacion" required>Fecha</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaCitacion"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaCitacion') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaCitacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaCitacion')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <FormLabel htmlFor="idTipoCitacion" required>Tipo de
                                                    citación</FormLabel>
                                                <InputLista
                                                    name="idTipoCitacion"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoCitacion') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoCitacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoCitacion"
                                                />
                                                <FormError message={errorOf('idTipoCitacion')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6">
                                                <label htmlFor="observacion"
                                                       className="form-label">Observaciones</label>
                                                <input
                                                    name="observacion"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.observacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                   <Accordion title="Información adicional">
                                       <DataTaggerFormRedux
                                           title="Información adicional de Juicio Citacion"
                                           processKey={props.processKey}
                                           entidad="JuicioCitacion"
                                           idEntidad={state.entity.id}
                                           disabled={props.disabled}
                                       />
                                   </Accordion>
                                </div>
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}


export default JuicioCitacionModal;